import { ref, watch } from 'vue'
import { refDebounced } from '@vueuse/core'
import type { ListProduct } from '~/types'

type UseProductSearchOptions = {
    perPage?: number
}

export function useProductSearch({
    perPage = 10
}: UseProductSearchOptions = {}) {
  const query = ref('')
  const page = ref(1)

  const catalogService = useCatalogService()

  const stableQuery = refDebounced(query, 300)

  const products = ref<ListProduct[]>([])
  const pending = ref(false)
  const error = ref<string | null>(null)

  watch([stableQuery, page], async () => {
    if (stableQuery.value.trim() !== '') {
      pending.value = true
      try {
        const result = await catalogService.getProducts({
          search: stableQuery.value,
          page: page.value,
          perPage
        })
        products.value = result.data
      } catch (err) {
        console.error('Error fetching products:', err)
        error.value = 'Failed to fetch products'
      } finally {
        pending.value = false
      }
    } else {
      products.value = []
      error.value = null
    }
  })

 // Keep pending true for minimum duration to prevent skeleton flashing
  const pendingWithMinDuration = ref(false)
  const minDisplayTime = 300 // ms

  watch(pending, (newVal) => {
    if (newVal) {
      // Fetch started - show skeleton immediately
      pendingWithMinDuration.value = true
    } else {
      // Fetch completed - wait minimum time before hiding skeleton
      setTimeout(() => {
        pendingWithMinDuration.value = false
      }, minDisplayTime)
    }
  })
  
  return {
    query,
    products,
    page,
    pending: pendingWithMinDuration,
    error
  }
}
